export enum UserRole {
  Unknown = 0,
  Customer = 1,
  Lawyer = 2,
  SuperAdmin = 3,
  Checker = 4,
  LogoDetection = 5,
  OnlyData = 6,
}
